module.exports = __webpack_public_path__ + "img/search_logo.5dfad118.png";